import LocalScheme from '@nuxtjs/auth/lib/schemes/local'
import jwt_decode from 'jwt-decode'
import { LoginDocument, getMe, RefreshLogin } from '@/graphql/auth'
export default class CustomScheme extends LocalScheme {
  constructor (auth, options) {
    super(auth, options)
    this.$apolloHelpers = this.$auth.ctx.app.$apolloHelpers
    this.$apollo = this.$auth.ctx.app.apolloProvider.defaultClient
  }

  async _setToken (token) {
    if (this.options.globalToken) {
      // Set Authorization token for all axios requests
      const decode = jwt_decode(token)
      await this.$apolloHelpers.onLogin(token, this.$apollo, {
        expires: decode.exp / 86400,
        path: '/'
      })
    }
  }

  async _clearToken () {
    if (this.options.globalToken) {
      // Clear Authorization token for all axios requests
      // eslint-disable-next-line no-unused-expressions
      this.$apollo.queryManager.fetchQueryRejectFns
      this.$apollo.clearStore()
      await this.$apolloHelpers.onLogout()
    }
  }

  mounted () {
    if (this.options.tokenRequired) {
      const token = this.$auth.syncToken(this.name)
      this._setToken(token)
    }

    return this.$auth.fetchUserOnce()
  }

  // Override `fetchUser` method of `local` scheme
  async fetchUser (endpoint) {
    await this.$apollo.queryManager.fetchQueryRejectFns
    await this.$apollo.clearStore()
    await this.$apollo
      .query({
        query: getMe
      })
      .then(({ data }) => {
        if (data.me.id === '<nil>') {
          return new Error('Not login')
        }
        const user = []
        data.me.profile.fields.forEach((item, index) => {
          user[item.name] = item.value
        })

        const customUser = {
          ...user,
          id: data.me.id
        }

        this.$auth.setUser(customUser)
      })
      .catch((err) => {
        console.error(err)
        return err
      })
  }

  async setUserToken () {
    const refresh = this.$auth.getRefreshToken(this.name)
    if (refresh !== null) {
      await this._clearToken()
      await this._setToken(refresh)
      this.$apollo.mutate({
        mutation: RefreshLogin
      }).then(async (data) => {
        const token = data.data.RefreshLogin.jwt_token
        const refreshToken = data.data.RefreshLogin.jwt_refresh_token
        this.$auth.setToken(this.name, token)
        this.$auth.setRefreshToken(this.name, refreshToken)
       await this._setToken(token)
        return this.fetchUser()
      }).catch((e) => {
        console.error('refresh token fail')
        console.error(e)
        return new Error(e)
      })
    } else {
      return this.logout()
    }
  }

  async login (args) {
    // Ditch any leftover local tokens before attempting to log in
    await this.$auth.reset()

    const { data } = await this.$apollo.mutate({
      mutation: LoginDocument,
      variables: {
        form: args.form
      }
    })
    if (data.error !== undefined) {
      return new Error(data.error.message)
    }

    if (this.options.tokenRequired) {
      const token = data.Login.jwt_token
      const refreshToken = data.Login.jwt_refresh_token
      this.$auth.setToken(this.name, token)
      this.$auth.setRefreshToken(this.name, refreshToken)
      this._setToken(token)
    }

    if (this.options.autoFetchUser) {
      await this.fetchUser()
      setInterval(this.fetchUser.bind(this), 100000)
    }

    return data
  }

  logout (endpoint) {
    return this.reset()
  }

  reset () {
    if (this.options.tokenRequired) {
      this._clearToken()
    }

    this.$auth.setUser(false)
    this.$auth.setToken(this.name, false)
    this.$auth.setRefreshToken(this.name, false)

    return Promise.resolve()
  }
}

/* eslint-disable no-unused-vars */
const DEFAULTS = {
  tokenRequired: true,
  tokenType: 'Bearer',
  globalToken: true,
  tokenName: 'Authorization',
  autoFetchUser: true
}
/* eslint-enable */
